import React from 'react'
import {Link} from 'react-router';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';


export default class HomeFooter extends React.Component {

	changeColorScroll(){


	}

	render(){
		return (

			<div >
				<div className="home_footer hide_overflow">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 ">

								<div className="middle_main">
									<h2>It’s time to partner up</h2>
									<p>
										Tipigo is on the forefront of a new investing dynamic, presenting a new trading approach that uses the fundamentals, yet is fundamentally different. <br/><br/> We welcome investors of all types to join us on the ride.
									</p>
									<br/>
									<Link to="contact_us" className="btn btn-success btn-raised contact_us_btn">CONTACT US</Link>
								</div>
							</div>
						</div>
			    	</div>

			    </div>
			    {/*<div className="home_footer_buttom">
			    	<div className="container">
				    	<div className="row">
				    		<div className="col-sm-15 col-xs-6 ">
				    			<h4 className="footer-h">LEARN MORE</h4>
				    			<Link>Management</Link><br/>
				    			<a>Investors</a><br/>
				    			<a>Service</a><br/>
				    		</div>
				    		<div className="col-sm-15 col-xs-6">
				    			<h4 className="footer-h">LEGAL</h4>
				    			<a>Terms Of use</a><br/>
				    			<a>Privacy Policy</a><br/>
				    			<a>Contract documents</a><br/>
				    		</div>
				    		<div className="col-sm-15 col-xs-6">
				    			<h4 className="footer-h">SUPPORT</h4>
				    			<a>Contact</a><br/>
				    			<a>FAQ</a><br/>

				    		</div>
				    		<div className="col-sm-15 col-xs-6">
				    			<h4 className="footer-h">FOLLOW US</h4>
				    			<br/>
				    			<i className="fa fa-linkedin" aria-hidden="true"></i>
				    			<i className="fa fa-twitter" aria-hidden="true"></i>
				    			<i className="fa fa-facebook" aria-hidden="true"></i>
				    		</div>
				    		<div className="col-sm-15 col-xs-12">
				    			<h4 className="footer-h">TIPIGO UPDATES</h4>

				    			<TextField floatingLabelText="Email address" className="tpgo_textfield tpgo_textfield_short"/>
				    			<RaisedButton label="Submit" labelColor="black" backgroundColor="#c7c7c7 " />

				    		</div>
				    	</div>
				    	<div className="row copyright_row">
				    		<div className="col-sm-6">
				    			<span>
				    				Copyright © Tipigo | All rights reserved. 2016
				    			</span>
				    		</div>
				    		<div className="col-sm-6 text-right">
				    			<span>
				    				Design by muze
				    			</span>
				    		</div>
				    	</div>
				    </div>
			    </div>*/}
			</div>

		);
	}

}



// WEBPACK FOOTER //
// ./src/js/components/HomeFooter.js